import OfferItem from '@/models/OfferItem';

export default class OfferItemRepository {
    public static getById(offerItemId: string) {
        return OfferItem.query().whereId(offerItemId).withAllRecursive().first();
    }
}
